import clsx from 'clsx';
import { useExperiment } from '@hungryroot/experiments';
import { Heading } from '@hungryroot/ramen';
import { type ContainerFrequencyOptions } from '@hungryroot/rest';
import { type QuizFrequencyKeys } from '../../quiz-hooks';
import { ControlFrequency } from '../ControlFrequency/ControlFrequency';

import styles from './FrequencyPicker.module.css';

type Props<T extends QuizFrequencyKeys> = {
  testid?: string;
  controlTestId?: string;
  question: T;
  headingText: string;
  setTrackedFrequency?: (frequency: ContainerFrequencyOptions) => void;
};

export function FrequencyPicker<T extends QuizFrequencyKeys>({
  headingText,
  testid,
  controlTestId,
  question,
  setTrackedFrequency,
}: Props<T>) {
  const dietDrivenPreferencesVariant = useExperiment(175);
  return (
    <div
      data-testid={`${testid}-question-frequency`}
      ref={(el) => {
        if (el === null) {
          return;
        }

        el.scrollIntoView({ behavior: 'smooth' });
      }}
      className={clsx(styles.container, {
        [styles['container-variant']]:
          dietDrivenPreferencesVariant !== undefined &&
          dietDrivenPreferencesVariant > 0,
      })}
    >
      <Heading variant="H3" className={styles.title}>
        {headingText}
      </Heading>
      <ControlFrequency
        testid={controlTestId}
        question={question}
        setTrackedFrequency={setTrackedFrequency}
      />
    </div>
  );
}
